import { render } from "./QA.vue?vue&type=template&id=69ded50f&scoped=true"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"

import "./QA.vue?vue&type=style&index=0&id=69ded50f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69ded50f"

export default script